export default {
  emmitedCountry: 'Nicaragua y Estados Unidos'
}
